import { z } from 'zod';

export const activitySchema = z.object({
  libelle: z.string().min(1, 'Le libelle ne doit pas être vide').max(250, 'Le libelle ne doit pas dépasser 250 caractères'),
  categorieActiviteId: z.number().min(1, "La catégorie d'activité ne doit pas être vide"),
});
